module.exports = __webpack_public_path__ + "img/Angelone.a2e996bc.png";